<form [formGroup]="puFg">
    <snelstart-ui-select-form-control formControlName="uitkeringsPeriode"
                                      id="uitkeringsPeriode"
                                      label="Uitkeringsperiode"
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsPeriode"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
    <snelstart-ui-number-form-control formControlName="uitkeringsbedrag"
                                      id="uitkeringsbedrag"
                                      label="Bedrag uitkering per periode"
                                      [showAllDecimals]="false"
                                      [minValue]="1"
                                      align="right"
                                      prefix="€"
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-date-form-control formControlName="datumEersteUitkering"
                                    id="datumEersteUitkering"
                                    label="Datum eerste uitkering"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-select-form-control formControlName="afhankelijkVanLeven"
                                      id="afhankelijkVanLeven"
                                      label="Uitkeringen eindigen bij overlijden"
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsJaNee"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
  <div *ngIf="!this.puFg.getRawValue().afhankelijkVanLeven">
    <snelstart-ui-date-form-control formControlName="datumLaatsteUitkering"
                                    id="datumLaatsteUitkering"
                                    label="Datum laatste uitkering"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>
  </div>
  <div *ngIf="this.puFg.getRawValue().afhankelijkVanLeven">
    <snelstart-ui-date-form-control formControlName="geboorteDatumEersteVanLevenAfhankelijke"
                                    id="geboorteDatumEersteVanLevenAfhankelijke"
                                    label="Geboortedatum eerste persoon"
                                    placeholder="dd-mm-jjjj"
                                    class="me-1 custom-input-250"
                                    [required]=true
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>
  </div>
  <div *ngIf="this.puFg.getRawValue().afhankelijkVanLeven">
    <snelstart-ui-bsn-form-control formControlName="bsnEersteVanLevenAfhankelijke"
                                   id="bsnEersteVanLevenAfhankelijke"
                                   label="BSN eerste persoon"
                                   class="me-1 custom-input-250"
                                   [required]=true
                                   (change)="saveForm()"
    >
    </snelstart-ui-bsn-form-control>
  </div>
  <div *ngIf="this.puFg.getRawValue().afhankelijkVanLeven">
    <snelstart-ui-date-form-control formControlName="geboorteDatumTweedeVanLevenAfhankelijke"
                                    id="geboorteDatumTweedeVanLevenAfhankelijke"
                                    label="Geboortedatum tweede persoon"
                                    placeholder="dd-mm-jjjj"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>
  </div>
  <div *ngIf="this.puFg.getRawValue().afhankelijkVanLeven">
    <snelstart-ui-bsn-form-control formControlName="bsnTweedeVanLevenAfhankelijke"
                                   id="bsnTweedeVanLevenAfhankelijke"
                                   label="BSN tweede persoon"
                                   class="me-1 custom-input-250"
                                   (change)="saveForm()"
    >
    </snelstart-ui-bsn-form-control>
  </div>
</form>
